/* Balkan — comportamentele barei de sus.

   Patru lucruri, toate cerute de referinta clientului (aronia charlottenburg):
     1. starea LIPITA: la derulare bara se strange — pe desktop dispar telefonul
        si cererea de apel, pe telefon dispar logo-ul si randul lat de cautare,
        iar in locul lor apare caseta compacta dintre meniu si pictograme;
     2. ANIMATIA DE TASTARE din caseta de cautare;
     3. TOTALUL COSULUI de langa pictograma;
     4. trimiterea in fundal a cererii de apel inapoi.                        */
(() => {
  if (window.__bkHeader) return;
  window.__bkHeader = true;

  const header = document.getElementById('header-component');

  /* ------------------------------------------------------------ 1. LIPIT */

  if (header) {
    /* Pe Horizon pagina nu deruleaza mereu din <html>: continutul sta intr-un
       `.page-wrapper` cu scroll propriu. Citim ce e mai mare din cele doua, ca
       sa mearga in ambele cazuri. */
    const wrap = document.querySelector('.page-wrapper');

    /* ⚠️ 18 sept. 2026 — starea nu mai depinde de CAT s-a derulat, ci de
       DIRECTIE. Cererea clientului: la derulare in jos bara compacta (logo la
       stanga, fara telefon, cautare lata), la derulare in sus bara completa
       (telefon + cerere de apel, logo centrat).

       Inainte era un simplu prag `y > 40`: odata coborat, bara ramanea stransa
       oricat ai fi urcat inapoi. */
    /* ⚠️ 7 oct. 2026 — PALPAIREA. Pragul de 6px nu era destul.

       Masurat: pe telefon bara trece de la 108px la 44px, deci schimbarea de
       stare MUTA 64px de continut. Mutarea produce ea insasi evenimente de
       derulare, care se citesc ca schimbare de directie si comuta starea
       inapoi — bucla. La o singura derulare dus-intors starea comuta de 18 ori,
       iar pagina sarea de fiecare data. Asta vedea clientul ca „glitch".

       Doua masuri, amandoua necesare:
         • se acumuleaza distanta parcursa IN ACEEASI directie si se comuta
           abia la 48px, nu la prima miscare de 6px — degetul are micro-reveniri;
         • dupa fiecare comutare urmeaza o RACIRE de 350ms in care evenimentele
           se ignora, exact cat tine reflow-ul provocat de noi. Asta rupe bucla. */
    /* ⚠️ Pragul era 40px — sub inaltimea barei insasi (108px pe telefon).
       Deci starea compacta se putea declansa inca din primii pixeli, iar saltul
       de 64px readucea pozitia sub prag, care forta la loc bara completa:
       doua comutari inutile in prima secunda. Pragul trebuie sa fie DUPA ce
       bara a iesit din ecran. */
    const TOP = 140;     // deasupra pragului bara e mereu completa
    const PRAG = 48;     // cat trebuie sa se miste constant in aceeasi directie
    const RACIRE = 600;  // ms de tacere dupa o comutare
    let last = null, prevY = 0, acum = 0, pana = 0;

    const set = (on) => {
      if (on === last) return;
      last = on;
      header.classList.toggle('bk-stuck', on);
      /* reluam referinta DUPA schimbarea de inaltime, nu inainte */
      prevY = Math.max(window.scrollY || 0, wrap ? wrap.scrollTop : 0);
      acum = 0;
      pana = Date.now() + RACIRE;
    };

    const sync = () => {
      const y = Math.max(window.scrollY || 0, wrap ? wrap.scrollTop : 0);
      /* ⚠️ RACIREA SE VERIFICA PRIMA. Daca ramura `y <= TOP` ruleaza inainte,
         saltul provocat de noi poate readuce pozitia sub prag si anuleaza
         comutarea la 60ms dupa ce s-a facut. */
      if (Date.now() < pana) { prevY = y; return; }
      if (y <= TOP) { prevY = y; acum = 0; set(false); return; }
      const d = y - prevY;
      prevY = y;
      if (!d) return;
      /* la schimbarea de directie pornim numaratoarea de la zero */
      if ((d > 0) !== (acum > 0)) acum = 0;
      acum += d;
      if (Math.abs(acum) < PRAG) return;
      set(acum > 0);
    };
    addEventListener('scroll', sync, { passive: true });
    if (wrap) wrap.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    sync();
  }

  /* --------------------------------------------------------- 2. TASTAREA */

  const typers = [...document.querySelectorAll('[data-bk-type]')];
  if (typers.length) {
    const src = document.querySelector('[data-bk-terms]');
    const terms = (src ? src.dataset.bkTerms : '').split('|').map((t) => t.trim()).filter(Boolean);
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ⚠️ PERFORMANȚĂ (15 oct. 2026): animația pornește abia la 2,5 s DUPĂ `load`.
       Pornită la 900 ms, schimba textul de ~15 ori pe secundă exact cât browserul
       încerca să afișeze pagina, iar fiecare literă trezea observatorii de pagină
       (rafturi, recomandările din coș). Lighthouse: ~0,3–0,5 s de fir principal
       pe fiecare pagină. Decorul așteaptă; conținutul nu. */
    const porneste = (fn) => {
      const run = () => setTimeout(fn, 2500);
      if (document.readyState === 'complete') run(); else addEventListener('load', run, { once: true });
    };
    if (terms.length && !reduce) porneste(() => {
      typers.forEach((el) => {
        el.textContent = '';
        el.insertAdjacentHTML('beforeend',
          '<span class="bk-type__pre">Caută </span><span class="bk-type__w"></span><i class="bk-type__c" aria-hidden="true"></i>');
      });
      const words = typers.map((el) => el.querySelector('.bk-type__w'));

      let i = 0, j = 0, del = false, hidden = false;
      document.addEventListener('visibilitychange', () => { hidden = document.hidden; });

      const step = () => {
        if (hidden) return setTimeout(step, 600);
        const t = terms[i % terms.length].toLowerCase();
        j += del ? -1 : 1;
        const txt = t.slice(0, j);
        /* ⚠️ PERFORMANȚĂ (15 oct. 2026): se schimbă VALOAREA nodului de text, nu nodul.
           `textContent = …` înlocuia nodul la fiecare literă (mutație de tip childList),
           iar foile cu `body:has(…)` obligau browserul să reverifice stilurile pe toată
           pagina: măsurat pe CPU ×4, 395 ms de stil și 1,96 s de fir principal la fiecare
           5 secunde de animație. Cu `nodeValue`: 39 ms și 0,85 s. Arată identic. */
        words.forEach((w) => {
          if (!w.firstChild) w.appendChild(document.createTextNode(''));
          w.firstChild.nodeValue = txt;
        });

        let wait = del ? 45 : 85;
        if (!del && j === t.length) { del = true; wait = 1800; }
        else if (del && j === 0) { del = false; i++; wait = 320; }
        setTimeout(step, wait);
      };
      step();
    });
  }

  /* ------------------------------------------------------ 3. TOTAL COS */

  const totals = [...document.querySelectorAll('[data-bk-cart-total]')];
  if (totals.length) {
    const money = (c) => {
      const v = c / 100;
      const s = v.toLocaleString('ro-RO', {
        minimumFractionDigits: Number.isInteger(v) ? 0 : 2,
        maximumFractionDigits: 2,
      });
      return s + ' lei';
    };
    const refresh = async () => {
      try {
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const c = await r.json();
        totals.forEach((t) => { t.textContent = money(c.total_price); });
      } catch { /* reteaua a picat: ramane cifra randata de Liquid */ }
    };
    /* Nu ascultam un eveniment al temei: numele lui e detaliu intern al
       Horizon-ului. Bulina de pe cos, in schimb, e chiar lucrul pe care il vede
       omul — cand ea se schimba, s-a schimbat si cosul. */
    const bubble = document.querySelector('#cart-bubble-text, .cart-bubble');
    if (bubble) new MutationObserver(refresh).observe(bubble, { childList: true, subtree: true, characterData: true });
    addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  }

  /* ------------------------------------------------- 4. CEREREA DE APEL */

  /* Formularul se trimite NORMAL, nu in fundal: hCaptcha-ul Shopify il prinde
     la `submit` si adauga tokenul, iar pagina revine cu `?contact_posted=true`.
     Trimis cu `fetch`, ocolea verificarea si raspunsul 200 (pagina de eroare sau
     de verificare) arata „Multumim" fara ca cererea sa ajunga (pana la 28 oct. 2026).
     Aici doar anuntam ca se trimite. */
  const cb = document.getElementById('bk-callback');
  if (cb) {
    const msg = document.querySelector('[data-bk-cb-msg]');
    cb.addEventListener('submit', () => {
      const input = cb.querySelector('input[type="tel"]');
      if (input && !input.checkValidity()) return;          // lasam browserul sa arate eroarea
      if (msg) { msg.textContent = 'Se trimite…'; msg.hidden = false; msg.classList.remove('is-err'); }
    });
  }
})();
